import { CustomClaimValue, RoleValue, useAuth } from "@app/shared";

type ClaimSource = ReturnType<typeof useAuth>["userClaims"];

/**
 * Non-hook form of useHasClaim, for checks that vary per row (e.g. one device per table row) where
 * a hook can't be called in a loop. Pass `useAuth().userClaims`.
 */
export function hasClaim(userClaims: ClaimSource, claim: CustomClaimValue, organizationId?: string, facilityId?: string) {
    // Use some()/includes() rather than find(): CustomClaimValue.EditDetails is 0, so find() returns the
    // matched element (0) and the surrounding && silently evaluates to false, denying the permission.
    return !!userClaims?.some(uc => uc.role === RoleValue.Administrator && uc.claims.includes(CustomClaimValue.SuperAdmin)) ||
        !!userClaims?.some(uc => (uc.entityId === organizationId || uc.entityId === facilityId) && uc.claims.includes(claim));
}

export function useHasClaim(claim: CustomClaimValue, organizationId?: string, facilityId?: string) {
    const auth = useAuth();
    return hasClaim(auth.userClaims, claim, organizationId, facilityId);
}
